import * as React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { withRouter } from 'react-router-dom';

// Assets
import { brandColors, device } from '../../styles/variables';

const Link = styled.span`
  width: 100%;
  color: ${({ color }) => color};
  cursor: pointer;

  @media ${device.laptop} {
    cursor: ${({ constantLink }) => (constantLink ? 'pointer' : 'default')};
    color: ${({ color, originalColor, constantLink }) => (constantLink ? color : originalColor)};
  }
`;

class Hyperlink extends React.PureComponent {
  goToLink() {
    const { linkAddress, internalLink, history } = this.props;

    if (linkAddress !== '') {
      if (!internalLink) {
        window.open(linkAddress, '_blank');
      } else {
        history.push(linkAddress);
      }
    }
  }

  render() {
    const { constantLink, linkName, color, originalColor } = this.props;

    return (
      <Link
        color={color}
        originalColor={originalColor}
        constantLink={constantLink}
        onClick={() => this.goToLink()}
      >
        {linkName}
      </Link>
    );
  }
}

Hyperlink.defaultProps = {
  constantLink: false,
  linkName: 'Link name',
  linkAddress: 'www.google.com',
  color: brandColors.yellow,
  originalColor: brandColors.white,
  internalLink: false
};

Hyperlink.propTypes = {
  constantLink: PropTypes.bool,
  linkName: PropTypes.string,
  linkAddress: PropTypes.string,
  color: PropTypes.string,
  originalColor: PropTypes.string,
  internalLink: PropTypes.bool,
  history: PropTypes.any.isRequired
};

export default withRouter(connect()(Hyperlink));



// WEBPACK FOOTER //
// ./src/components/Hyperlink/index.jsx